/*
  Lazy-autoplay video — odracza pobieranie autoodtwarzanych wideo poniżej pierwszego ekranu.
  Problem: homepage ma 5 autoplay-wideo; wszystkie startują pobieranie przy wejściu i na
  wolnym łączu konkurują o pasmo, opóźniając LCP/render. Hero i promo (powyżej folda)
  zostają nietknięte — tutaj celujemy wyłącznie w sekcje poniżej folda po stabilnych ID.

  Mechanizm: odpina src ze <source>/<video>, zatrzymuje wczytywanie (load()), zdejmuje
  autoplay. Gdy sekcja zbliża się do viewportu (IntersectionObserver, margines 300px) —
  przywraca src, ładuje i odpala odtwarzanie (muted, w pętli — bez interakcji usera).
  Brak IntersectionObserver → natychmiastowe przywrócenie (zero regresji na starych przeglądarkach).
*/
(function () {
  // ID sekcji w szablonie JSON mają postać shopify-section-template--<id>__<klucz>,
  // dlatego dopasowujemy po fragmencie klucza, nie po pełnym ID.
  var SEL = [
    '[id*="home-fabric-samples"] video',
    '[id*="home-feature-carousel"] video',
    '[id*="home-instagram"] video'
  ].join(', ');

  function defer(video) {
    if (video.dataset.lazyApplied) return;
    video.dataset.lazyApplied = '1';

    var stashed = false;
    var sources = video.querySelectorAll('source[src]');
    for (var i = 0; i < sources.length; i++) {
      sources[i].dataset.lazySrc = sources[i].getAttribute('src');
      sources[i].removeAttribute('src');
      stashed = true;
    }
    if (video.hasAttribute('src')) {
      video.dataset.lazySrc = video.getAttribute('src');
      video.removeAttribute('src');
      stashed = true;
    }
    if (!stashed) return;

    if (video.hasAttribute('autoplay')) {
      video.removeAttribute('autoplay');
      video.dataset.lazyAutoplay = '1';
    }
    try { video.load(); } catch (e) {}
  }

  function restore(video) {
    if (video.dataset.lazyRestored) return;
    video.dataset.lazyRestored = '1';

    var sources = video.querySelectorAll('source[data-lazy-src]');
    for (var i = 0; i < sources.length; i++) {
      sources[i].setAttribute('src', sources[i].dataset.lazySrc);
    }
    if (!sources.length && video.dataset.lazySrc) {
      video.setAttribute('src', video.dataset.lazySrc);
    }
    try { video.load(); } catch (e) {}

    if (video.dataset.lazyAutoplay) {
      video.muted = true;
      var p = video.play();
      if (p && typeof p.catch === 'function') { p.catch(function () {}); }
    }
  }

  function init() {
    var vids = document.querySelectorAll(SEL);
    if (!vids.length) return;

    if (!('IntersectionObserver' in window)) {
      for (var i = 0; i < vids.length; i++) { restore(vids[i]); }
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          restore(entry.target);
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '300px 0px' });

    for (var j = 0; j < vids.length; j++) {
      defer(vids[j]);
      io.observe(vids[j]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
